import React from 'react';
import { Box, Container, Heading, SimpleGrid, Text, Icon, Flex, VStack, useColorModeValue, Divider } from '@chakra-ui/react';
import { Server, Shield, Lock, Database, Code, BookOpen, GitBranch } from 'lucide-react';
import { motion } from 'framer-motion';
const MotionBox = motion(Box);
const ServiceCard = ({
  title,
  description,
  icon,
  index
}) => {
  const cardBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  return <MotionBox p={6} borderRadius="lg" bg={cardBg} boxShadow="md" border="1px" borderColor={borderColor} transition={{
    duration: 0.3
  }} whileHover={{
    y: -5,
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
  }} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay: index * 0.1
  }} data-id="element-256">
      <Flex w={12} h={12} align="center" justify="center" borderRadius="full" bg="blue.100" color="blue.600" mb={4} data-id="element-257">
        <Icon as={icon} boxSize={6} data-id="element-258" />
      </Flex>
      <Heading as="h3" size="md" mb={3} data-id="element-259">
        {title}
      </Heading>
      <Text color={useColorModeValue('gray.600', 'gray.300')} data-id="element-260">
        {description}
      </Text>
    </MotionBox>;
};
export function Services() {
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const services = [{
    title: 'Secure Backend Development',
    description: 'Building robust APIs and services with security at the core, using Django/DRF, Node.js, and other technologies.',
    icon: Server
  }, {
    title: 'Security Assessment',
    description: 'Comprehensive vulnerability assessment and penetration testing following OWASP standards.',
    icon: Shield
  }, {
    title: 'Authentication Systems',
    description: 'Secure OAuth/JWT authentication, multi-factor authentication, and role-based access control systems.',
    icon: Lock
  }, {
    title: 'Database Architecture',
    description: 'Design and optimization of database systems with security, performance, and scalability in mind.',
    icon: Database
  }, {
    title: 'API Security',
    description: 'Securing APIs against common vulnerabilities, implementing rate limiting, and preventing abuse.',
    icon: Code
  }, {
    title: 'STEM Robotics Education',
    description: 'Specialized training and educational programs for schools across Ghana, focusing on robotics and programming.',
    icon: BookOpen
  }, {
    title: 'DevSecOps Integration',
    description: 'Implementing security throughout the CI/CD pipeline and development lifecycle.',
    icon: GitBranch
  }];
  return <Box id="services" py={20} bg={bgColor} width="100%" data-id="element-261">
      <Container maxW="1200px" data-id="element-262">
        <VStack spacing={12} data-id="element-263">
          <VStack spacing={4} textAlign="center" maxW="800px" data-id="element-264">
            <MotionBox initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} data-id="element-265">
              <Heading as="h2" size="xl" data-id="element-266">
                Services
              </Heading>
            </MotionBox>
            <Divider width="100px" borderColor="blue.500" borderWidth={2} data-id="element-267" />
            <Text fontSize="lg" color={useColorModeValue('gray.600', 'gray.300')} data-id="element-268">
              Specialized technical services with a focus on security and
              backend excellence
            </Text>
          </VStack>
          <SimpleGrid columns={{
          base: 1,
          md: 2,
          lg: 3
        }} spacing={10} data-id="element-269">
            {services.map((service, index) => <ServiceCard key={index} index={index} {...service} data-id="element-270" />)}
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>;
}